import { ErrorModel } from "../../core/cms-api/models";
import * as errorConstants  from "../constants/error.constatnts";

export class ErrorUtil {
    static convertToErrorModel(e: unknown): ErrorModel {
        if (typeof e === 'string') {
            return { errorCode: errorConstants.DefaultFeErrorCode, errorMessage: e }
        } else if (e instanceof Error) {
            return { errorCode: errorConstants.DefaultFeErrorCode, errorMessage: e.message }
        }

        return { errorCode: errorConstants.DefaultFeErrorCode, errorMessage: errorConstants.DefaultFeErrorMessage }
    }
}